import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { RmpvPecaService } from "../rmpv-peca-service/rmpv-peca.service";
import { ConversaoLibraConverte } from "../../../../shared/conversao-libra/conversao-libra-converte";
import { Filtros } from "../../../../shared/crud/Filtro/Filtros";
import { ListaBase } from "../../../../shared/crud/ListaBase";
import { IColunaGrid } from "../../../../shared/gridview/estrutura/IColunaGrid";
import { EstruturaGridViewBuilder } from "../../../../shared/gridview/EstruturaGridViewBuilder";
import { Parametro } from "../../../../shared/service-base/parametro";
import { TotalizadorDetalhes } from "./totalizador-detalhes";
import { TotalizadorResumo } from "./totalizador-resumo";


@Component({
  selector: 'app-rmpv-peca-lista',
  templateUrl: './rmpv-peca-lista.component.html',
  styleUrls: ['./rmpv-peca-lista.component.css'],
})

export class RmpvPecaListaComponent extends ListaBase implements OnInit {

  arrayTranslate = [{ categoria: "Cliente", chave: "rmpv.peca.cliente" },
  { categoria: "Garantia", chave: "rmpv.peca.garantia" },
  { categoria: "Funilaria e Pintura", chave: "rmpv.peca.funilariaPintura" },
  { categoria: "Acessório", chave: "rmpv.peca.acessorio" },
  { categoria: "Motos usadas", chave: "rmpv.peca.motosUsada" },
  { categoria: "Outras Internas", chave: "rmpv.peca.outraInterna" },
  { categoria: "Cortesia", chave: "rmpv.peca.cortesia" },
  { categoria: "Revisão", chave: "rmpv.peca.revisao" },
  { categoria: "Seguro/Franquia", chave: "rmpv.peca.seguroFranquia" },
  { categoria: "Outras", chave: "rmpv.peca.outra" },
  { categoria: "Retorno", chave: "rmpv.peca.retorno" },
  { categoria: "Recall", chave: "rmpv.peca.recall" },
  { categoria: "Venda balcão", chave: "rmpv.peca.vendaBalcao" },
  { categoria: "Valor Devolução", chave: "rmpv.peca.valorDevolucao" },
  ];

  dadosCache = [];
  dadosMarcaCache = [];

  visualizarTotalRegistros: boolean;

  dadosHorizontal: any[] = [];
  estruturaHorizontal: IColunaGrid[] = [];
  totalHorizontal: any[] = [];

  dadosResumo: TotalizadorResumo[] = [];
  dadosMarca: TotalizadorDetalhes[] = [];

  estruturaDetalhe: IColunaGrid[] = [];
  estruturaDetalheTotal: IColunaGrid[] = [];

  marca: any;
  total: TotalizadorResumo;
  totalInternas: TotalizadorResumo;
  totalMarca: TotalizadorDetalhes;

  habilitaDetalheMarca = false;


  public exibirBotaoDetalhes: boolean;
  subscription;

  detalhe = {
    descricao: 'Ver detalhado por mês',
    icone: 'fa fa-calendar',
    acao: function () {
      this.router.navigateByUrl(this.obterUrlComFiltros());
    }.bind(this)
  }

  constructor(service: RmpvPecaService,
    toastr: ToastrService, router: Router,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);

    this.exibirBotaoNovo = false;
    this.listagemComPaginacao = false;
    this.quantidadeRegistrosPorPagina = 5;
    this.visualizarTotalRegistros = false;
    this.visualizarTotalInterna = true; // Habilita visualizar a somatória de valores RMPV interna
    this.visualizarTotalGeral = true;  // Habilita visualizar a somatória de valores RMPV geral
    this.exibirBotaoDetalhes = true;
    this.exibirIconBotaoDetalhes = false; // habilita/desabilita o icone da coluna detalhe  
    this.exibirBotaoDetalhesIcon = true;  // habilita/desabilita o icone de download
    this.nomeModulo = 'Peças';
  }

  ngOnInit() {
    this.buscar();

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewChecked() {
  }

  obterUrlComFiltros(): string {
    let url = '';
    for (const filtro in this.filtros) {
      if (this.filtros.hasOwnProperty(filtro)) {
        url += url ? '&' + filtro + '=' + this.filtros[filtro] : '?' + filtro + '=' + this.filtros[filtro];
      }
    }
    return 'rmpv/peca/mensal' + url;
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  getDados(response: any): any {
    return this.carregarMarcas(response['marcas']);
  }

  limpar() {
    this.dadosResumo = [];
    this.dadosMarca = [];
    this.total = new TotalizadorResumo();
    this.totalInternas = new TotalizadorResumo();
    this.totalMarca = new TotalizadorDetalhes(0, 'Total');
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }

    this.service.listar([], objFiltro)
      .then(itens => {
        this.carregarMarcas(itens['marcas']);
      });
  }

  carregarMarcas(lista: any[]): any {
    this.limpar();

    lista.forEach(element => {
      element.dados.forEach(element => {
        element.nome = this.categoriaTranslate(element.nome);
        element.original = this.conversaoLibraConverte.conversaoLibra(element.original, null, null);
        element.paralelo = this.conversaoLibraConverte.conversaoLibra(element.paralelo, null, null);
        element.lubrificante = this.conversaoLibraConverte.conversaoLibra(element.lubrificante, null, null);
        element.pneu = this.conversaoLibraConverte.conversaoLibra(element.pneu, null, null);
      });
      this.totalizarMarca(element.dados);
      this.marca = lista[0].marca;

    });

    this.carregarEstruturaResumo();

    return this.dadosResumo;
  }

  categoriaTranslate(item) {
    if (item == 'Cliente') {
      return this.translate.currentLang == 'br' ? 'Cliente' : 'Client';
    }
    if (item == 'Garantia') {
      return this.translate.currentLang == 'br' ? 'Garantia' : 'Warranty';
    }
    if (item == 'Funilaria e Pintura') {
      return this.translate.currentLang == 'br' ? 'Funilaria e Pintura' : 'Auto body and Paint';
    }
    if (item == 'Acessório') {
      return this.translate.currentLang == 'br' ? 'Acessório' : 'Accessory';
    }
    if (item == 'PDI') {
      return 'PDI';
    }
    if (item == 'Retorno') {
      return this.translate.currentLang == 'br' ? 'Retorno' : 'Return';
    }
    if (item == 'Recall') {
      return 'Recall';
    }
    if (item == 'Motos usadas') {
      return this.translate.currentLang == 'br' ? 'Motos usadas' : 'Used motorcycles';
    }
    if (item == "Carros usados") {
      return item = this.translate.currentLang == 'br' ? 'Carros Usados' : 'Used Cars';
    }
    if (item == "Cortesia") {
      return item = this.translate.currentLang == 'br' ? 'Cortesia' : 'Courtesy';
    }
    if (item == "Revisão") {
      return item = this.translate.currentLang == 'br' ? 'Revisão' : 'Revision';
    }
    if (item == "Seguro/Franquia") {
      return item = this.translate.currentLang == 'br' ? 'Seguro/Franquia' : 'Insurance/Deductible';
    }
    if (item == 'Outras Internas') {
      return this.translate.currentLang == 'br' ? 'Outras Internas' : 'Other Interns';
    }
    if (item == 'Outras') {
      return this.translate.currentLang == 'br' ? 'Outras' : 'Other';
    }
    if (item == 'Venda balcão') {
      return this.translate.currentLang == 'br' ? 'Venda balcão' : 'Sale counter';
    }
    if (item == 'Valor Devolução') {
      return this.translate.currentLang == 'br' ? 'Valor Devolução' : 'Return Value';
    }
  }

  carregarEstruturaDetalheMarca() {
    this.estruturaDetalhe = this.carregarGridDetalhes();
    this.estruturaDetalheTotal = this.carregarTotalGridDetalhes(this.totalMarca);
  }


  private encontrarCategoriaResumo(element: any) {
    const index = this.dadosResumo.findIndex((item) => element.id === item.id);

    let categoria: TotalizadorResumo;

    if (index === -1) {
      categoria = new TotalizadorResumo();
      categoria.id = element.id;
      categoria.categoria = element.nome;
      this.dadosResumo.push(categoria);
    } else {
      categoria = this.dadosResumo[index];
    }

    return categoria;
  }

  private totalizarDetalhe(element: any, dados: TotalizadorDetalhes[], totalizador: TotalizadorDetalhes) {
    const index = dados.findIndex((item) => element.id === item.id);

    let categoria: TotalizadorDetalhes;

    if (index === -1) {
      categoria = new TotalizadorDetalhes(element.id, element.nome);
      dados.push(categoria);
    } else {
      categoria = dados[index];
    }

    this.adicionarValoresDetalhes(categoria, element);
    this.adicionarValoresDetalhes(totalizador, element);

    return categoria;
  }

  private adicionarValoresDetalhes(categoria: TotalizadorDetalhes, element: any) {
    categoria.original += element.original;
    categoria.paralelo += element.paralelo;
    categoria.lubrificante += element.lubrificante;
    categoria.pneu += element.pneu;
  }

  /*********     Totalizador     ********/
  totalizarMarca(lista: any[]) {
    lista.forEach(element => {
      this.totalizarDetalhe(element, this.dadosMarca, this.totalMarca);

      const categoria: TotalizadorResumo = this.encontrarCategoriaResumo(element);

      categoria.valorMarca += element.original + element.paralelo + element.lubrificante + element.pneu;

      this.total.valorMarca += categoria.valorMarca;
      this.totalInternas.valorMarca += element.interna ? element.original + element.paralelo + element.lubrificante + element.pneu : 0;

      this.estruturaDetalheTotal = this.carregarTotalGridDetalhes(this.totalMarca);
    });
  }


  public exibirDetalhesMarca(ctx: RmpvPecaListaComponent) {
    this.carregarEstruturaDetalheMarca();
    ctx.habilitaDetalheMarca = true;
  }


  private carregarEstruturaResumo() {
    const ctx = this;

    this.estrutura = new EstruturaGridViewBuilder()
      .addColunaW('categoria', 'rmpv.peca.titulo', '200px')
      .addColunaNumericaFormatadaWAction('valorMarca', this.marca, '', function () { ctx.exibirDetalhesMarca(ctx); })
      .build();

    var value1 = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.totalInternas.valorMarca);
    this.estruturaInterna = new EstruturaGridViewBuilder()
      .addColunaW('', 'rmpv.peca.internaRetornoUsado', '200px')
      .addColunaNumerica('', value1.replace("R$", ""))
      .build();

    var value2 = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.total.valorMarca);
    this.estruturaTotal = new EstruturaGridViewBuilder()
      .addColunaW('', 'Total', '200px')
      .addColunaNumerica('', value2.replace("R$", ""))
      .build();

    this.carregarGridDetalhes();
  }

  private carregarGridDetalhes(): IColunaGrid[] {
    return new EstruturaGridViewBuilder()
      .addColunaW('nome', 'rmpv.peca.categorias', '100px')
      .addColunaNumerica('original', 'rmpv.peca.original')
      .addColunaNumerica('paralelo', 'rmpv.peca.paralelo')
      .addColunaNumerica('lubrificante', 'rmpv.peca.lubrificante')
      .addColunaNumerica('pneu', 'rmpv.peca.pneu')
      .build();
  }

  private carregarTotalGridDetalhes(totalizador: TotalizadorDetalhes): IColunaGrid[] {
    return new EstruturaGridViewBuilder()
      .addColunaW('', 'Total', '100px')
      .addColunaNumerica('', totalizador.original.toFixed(2))
      .addColunaNumerica('', totalizador.paralelo.toFixed(2))
      .addColunaNumerica('', totalizador.lubrificante.toFixed(2))
      .addColunaNumerica('', totalizador.pneu.toFixed(2))
      .build();
  }

  private ocultarMarca() {
    this.habilitaDetalheMarca = false;
  }

}
